import { render, staticRenderFns } from "./RoleTransformation.vue?vue&type=template&id=789fb3b2&scoped=true"
import script from "./RoleTransformation.vue?vue&type=script&lang=js"
export * from "./RoleTransformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789fb3b2",
  null
  
)

export default component.exports